import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default () => {
  const { colors } = useTheme();
  return {
    ratingContainer: cardList => css`
      position: absolute;
      top: ${cardList ? '0.625rem' : '0.9rem'};
      padding-left: ${cardList ? '2.75rem' : '3.75rem'};
      display: flex;
      column-gap: ${cardList ? '1px' : '3px'};
    `,
    star: cardList => css`
      width: ${cardList ? '0.5rem' : '0.6138rem'};
      height: ${cardList ? '0.5rem' : '0.5694rem'};
      background-color: ${colors.red_E02926};
      clip-path: polygon(
        50% 0%,
        61% 35%,
        98% 35%,
        68% 57%,
        79% 91%,
        50% 70%,
        21% 91%,
        32% 57%,
        2% 35%,
        39% 35%
      ); /* this will Creates the star shape */
      top: 4.95px;
      left: 61.94px;
    `,
  };
};
